var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00754483 18.3838C0.00845454 19.1268 0.790494 19.6093 1.45493 19.277L19.1061 10.4472C19.4745 10.2629 19.4745 9.73712 19.1061 9.55283L1.45493 0.723046C0.790494 0.390671 0.00845454 0.873234 0.00754483 1.61616L0.000298111 7.53432C0.000124376 7.6762 0.0993725 7.79881 0.238182 7.82819L9.11322 9.7065C9.4304 9.77363 9.4304 10.2264 9.11322 10.2935L0.238182 12.1718C0.0993725 12.2012 0.000124376 12.3238 0.000298111 12.4657L0.00754483 18.3838Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d4e5cf2e218ee66f1181988329eaff72.svg";
export { ForwardRef as ReactComponent };